import { apiGet, apiPost } from "../http";

export default {
  async getBCFashionCategoriesAPI() {
    return await apiGet(`api/uploadSettings/bcfashionCategories`);
  },
  async postBCFashionCategoriesAPI(data) {
    return await apiPost(`api/uploadSettings/bcfashionCategories`, data);
  },
  async getBCFCategoriesAPI() {
    return await apiGet(`api/uploadSettings/bcfCategories`);
  },
  async postBCFCategoriesAPI(data) {
    return await apiPost(`api/uploadSettings/bcfCategories`, data);
  },
};
